import { APIPost, APIGet } from "utilities/APIRequestHelper"
import { getOriginSourceByHost } from "core/apiURLBuilder"
import { SOURCE_SYSTEM } from "constants/uploadDocumentation"
import apiURLBuilder from "../core/apiURLBuilder"
import { recordLinkV2 } from "utilities/tagging"
import { cleanStartBase64, pdfBase64ToBinary } from "../utilities/filesHelper"

const POLLING_TIMER = 3000

const sendDocumentToDms = async ({ documentUri, customerId, base64, fileType, processLabel, howManyFiles }) => {
    recordLinkV2({
        categoriaEvento: `documentos/subida de documentacion/${processLabel}`,
        accionEvento: `subir archivo ${howManyFiles}`,
        etiquetaEvento: "api solicitud de subida",
    })

    const response = await fetch(documentUri, {
        method: "PUT",
        headers: {
            "Content-Type": fileType,
            "x-amz-meta-customers": customerId,
        },
        body: pdfBase64ToBinary(cleanStartBase64(base64)),
    })

    if (!response.ok) throw new Error()

    recordLinkV2({
        categoriaEvento: `documentos/subida de documentacion/${processLabel}`,
        accionEvento: `subir archivo ${howManyFiles}`,
        etiquetaEvento: "api documento subido ",
    })
}

const saveSlotIntoDms = async ({
    customerId,
    additionalInfo,
    documentType,
    confidential,
    dispatch,
    countryCode,
    processLabel,
    sendMail,
    howManyFiles
}) => {
    const originSource = getOriginSourceByHost()
    const data = {
        documentType,
        sourceSystem: SOURCE_SYSTEM,
        countryCode,
        originSource,
        confidential,
        customers: [
            {
                customerCode: customerId,
            },
        ],
        sendMail
    }

    if (additionalInfo) {
        data.additionalInfo = additionalInfo
        data.observations = additionalInfo
    }

    const params = {
        query: data,
    }

    recordLinkV2({
        categoriaEvento: `documentos/subida de documentacion/${processLabel}`,
        accionEvento: `subir archivo ${howManyFiles}`,
        etiquetaEvento: "api solicitud url",
    })

    const { documentUri, documentId } = await APIPost({
        endpoint: "apiDocumentsDms",
        dispatch,
        params,
    })

    return { documentUri, documentId }
}

const requestDocumentStatus = async ({ dispatch, documentId }) => {
    const { status } = await APIGet(dispatch, apiURLBuilder.getURL("apiDocumentsDmsPolling", { documentId }))
    return status
}

const checkIfDocumentItsUploadedByPolling = async ({ dispatch, documentId }) => {
    return new Promise((resolve) => {
        const pollingDocumentsInterval = setInterval(async () => {
            const isUploaded = await requestDocumentStatus({ dispatch, documentId })
            const onFinishUpload = () => {
                clearInterval(pollingDocumentsInterval)
                resolve()
            }

            isUploaded && onFinishUpload()
        }, POLLING_TIMER)
    })
}

const sendFileToDMS = async ({
    file: { validationError, base64, file: { type } },
    customerId,
    additionalInfo,
    documentType,
    confidential,
    dispatch,
    countryCode,
    processLabel,
    sendMail,
    howManyFiles
}) => {
    if (validationError) {
        return
    }

    const { documentUri, documentId } = await saveSlotIntoDms({
        customerId,
        additionalInfo,
        documentType,
        confidential,
        dispatch,
        countryCode,
        processLabel,
        sendMail,
        howManyFiles
    })
    await sendDocumentToDms({ documentUri, customerId, base64, fileType: type, processLabel, howManyFiles })
    await checkIfDocumentItsUploadedByPolling({ dispatch, documentId })
}

export const uploadDocumentationToDms = ({
    uploadedFiles,
    customerId,
    additionalInfo,
    documentType,
    confidential,
    finishCallback,
    errorCallback,
    countryCode,
    processLabel,
}) => async (dispatch) => {
    try {
        const newAllUploadedFiles = [...uploadedFiles]
        const lastFile = newAllUploadedFiles.pop()
        const howManyFiles = uploadedFiles.length

        const allDocumentPromises = newAllUploadedFiles.map((file) => sendFileToDMS({
            file,
            customerId,
            additionalInfo,
            documentType,
            confidential,
            dispatch,
            countryCode,
            processLabel,
            sendMail: false,
            howManyFiles
        }))


        await Promise.all(allDocumentPromises)
        await sendFileToDMS({
            file: lastFile,
            customerId,
            additionalInfo,
            documentType,
            confidential,
            dispatch,
            countryCode,
            processLabel,
            sendMail: true,
            howManyFiles
        })

        finishCallback()
    } catch (e) {
        errorCallback()
    }
}
